import { withWebBasePath } from '../base-path';

/**
 * CDN 资源路径常量
 * 图片资源已上传到腾讯云 COS，通过 CDN 分发
 * CDN: https://cdn.domi.miaobi.cn
 * 上传路径: /fe/static/open-design/
 */

export const ASSET_CDN_BASE = 'https://cdn.domi.miaobi.cn/fe/static/open-design';

/** 神笔马良品牌 logo（与 HomeHero / 助手消息头像一致） */
export const BRAND_LOGO_URL =
  'https://cdn.domi.miaobi.cn/domi/public/brand/logo.png';

/** 根据相对路径获取 CDN 完整 URL */
export function assetUrl(relativePath: string): string {
  const path = relativePath.startsWith('/') ? relativePath.slice(1) : relativePath;
  return `${ASSET_CDN_BASE}/${path}`;
}

/** Resolve an asset from apps/web/public without escaping a sub-path deploy. */
export function publicAssetUrl(relativePath: string): string {
  const path = relativePath.startsWith('/') ? relativePath : `/${relativePath}`;
  return withWebBasePath(path);
}

/** 入口侧栏品牌图标（彩色渐变 app icon） */
export const APP_ICON_URL = assetUrl('icons/app-icon.svg');

/** 首页顶部品牌区域文案图（Domi Design 图形化 wordmark，透明底） */
export const DOMI_DESIGN_WORDMARK_URL = assetUrl('logo/domi-design-wordmark.webp');

/** 英文站首页顶部品牌小图标（蓝色边牧，冷色系） */
export const DOMI_BLUE_LOGO_URL = assetUrl('logo/domi-blue.png');

/** 首页背景插画（与 home-kids.css 中 .home-view 背景一致，loading 占位壳复用） */
export const HOME_BACKGROUND_URL = assetUrl('home/home-bg-4-v2.webp');

/** App 懒加载占位壳（od-loading-shell）里播放的 Domi 吉祥物透明 GIF */
export const LOADING_MASCOT_GIF_URL = assetUrl('loading/domi-mascot-loading.gif');
